import { uiActions } from '../ui-slice';
import { form6Actions } from './form6-slice';

import {
  doNavigation,
  logResponseFromAPI,
  verifyErrors,
} from '../../utils/helper-functions';
import { makeDataPaymentAndPolicy, getContractingPersonData } from '../../utils/form';
import { postEmitPolicy } from '../../requests/policy';
import { POST_EMIT_POLICY_URL } from '../../constants/constants';

export const form6Transaction = (
  token,
  idProcess,
  quoteId,
  values,
  preferredBeneficiary,
  prevFormData,
  currentStep,
  navigateHook,
) => {
  return async (dispatch) => {
    dispatch(uiActions.setLoaderStatus({
      type: 'message',
      message: 'Tu póliza se está generando.',
    }));
    dispatch(form6Actions.setFormData(values));

    const data = makeDataPaymentAndPolicy({
      ...prevFormData,
      form5: getContractingPersonData(prevFormData.form5, prevFormData.form4),
      form6: values,
      form7: { ...values, preferredBeneficiary },
      quoteId,
    });

    await postEmitPolicy(token, data.policy)
      .then((response) => {
        verifyErrors(response);
        dispatch(form6Actions.setPolicyEmissionData({
          emissionId: response.data.data.emission.id,
          numberPolicy: response.data.data.emission.numberPolicy,
          quoteId: response.data.data.emission.quoteId,
        }));

        logResponseFromAPI(
          idProcess,
          'Policy emission',
          response.status,
          'ok',
          POST_EMIT_POLICY_URL,
        );

        dispatch(uiActions.setLoaderStatus({
          type: 'success',
          message: 'Tu póliza ya fue generada, realiza el pago para finalizar tu contratación.',
        }));

        setTimeout(() => {
          doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
        }, 4000);
      })
      .catch((error) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: error?.message || 'Ocurrió un error al generar tu póliza.',
        }));
        logResponseFromAPI(
          idProcess,
          'Policy emission',
          error.response?.status || '5xx',
          `Soft error: ${error.message}`,
          POST_EMIT_POLICY_URL,
        );
        throw error;
      });
  };
};
